export const formatDatesForExcel = (date: string | null) : string => {
    if (date) {
        let formattedDate = new Date(date).toLocaleString();
        formattedDate = formattedDate.substring(0, 17);
        return formattedDate;
    } else {
        return "";
    }
};